<template>
  <div>
    <div
      class="demo__font--16 demo__weight--400 demo__color--black demo__margin-top--16"
    >
      {{ text }}
    </div>
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      class="demo__FormModal demo__margin-top--24"
    >
      <a-form-model-item
        :prop="field.field"
        :ref="field.field"
        v-for="field in fields"
        :key="field.field"
        :label="$t(field.locale)"
        class="demo__FormModal--required"
      >
        <a-input
          v-model="form[field.field]"
          v-bind="field.fieldAttrs"
          class="demo__input demo__FormModal--required"
          @change="validate"
        />
      </a-form-model-item>
      <a-form-model-item v-if="fieldError">
        <div class="demo__FormModal--result">
          {{ fieldError }}
        </div>
      </a-form-model-item>
      <a-form-model-item class="demo__margin-top--24">
        <a-button
          class="demo__button demo__button--base"
          :disabled="!validForm && !loading && !fieldError"
          :loading="loading"
          @click="updateFields"
        >
          {{ $t("Subs.Connectv2") }}
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    subsInfo: {
      required: false,
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      fieldError: undefined,
      validForm: false,
      emailPattern:
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
      form: {
        phone: undefined,
        email: undefined,
      },
    };
  },
  computed: {
    ...mapGetters(["api", "user", "isMobile", "subsPlans"]),
    text() {
      return this.$t("Subs.lets.text")
        .replace(
          "<PHONE>",
          !!!this.user?.phone ? this.$t("Subs.lets.modalTitle.phone") : ""
        )
        .replace(
          "<EMAIL>",
          (!!!this.user?.phone && !!!this.user?.email
            ? this.$t("Subs.lets.modalTitle.and")
            : "") +
            (!!!this.user?.email
              ? this.$t("Subs.lets.modalTitle.email").replace(
                  !!!this.user?.phone && !!!this.user?.email ? "у" : "",
                  ""
                )
              : "")
        );
    },
    fields() {
      return [
        {
          field: "phone",
          locale: "Phone",
          fieldAttrs: {
            type: "tel",
            autocomplete: "tel",
            placeholder: "+7",
          },
          rules: [
            {
              required: true,
              message: this.$t("Not valid phone"),
              trigger: "change",
            },
            {
              min: 11,
              message: this.$t("Not valid phone"),
              trigger: "change",
            },
            {
              max: 14,
              message: this.$t("Not valid phone"),
              trigger: "change",
            },
            {
              pattern: this.phonePattern,
              message: this.$t("Not valid phone"),
              trigger: "change",
            },
          ],
        },
        {
          field: "email",
          locale: "Email",
          fieldAttrs: {
            placeholder: this.$t("Email"),
          },
          rules: [
            {
              required: true,
              message: this.$t("Field required"),
              trigger: "change",
            },
            {
              pattern: this.emailPattern,
              message: this.$t("Not valid email"),
              trigger: "change",
            },
          ],
        },
      ].filter((rule) => {
        return !!!this.user[rule.field];
      });
    },
    rules() {
      return this.rulesObject(this.fields);
    },
  },
  created() {
    this.$accessModule("letsub", this);
  },
  methods: {
    rulesObject(rules) {
      let obj = {};
      rules.map((rule) => {
        obj[rule.field] = rule.rules;
      });
      return obj;
    },
    validate() {
      this.fieldError = undefined;
      this.$refs.ruleForm.validate((valid) => {
        this.validForm = valid;
      });
    },
    errorText(error) {
      if (Array.isArray(error)) {
        return error[0];
      }
      if (typeof error === "string") {
        return error;
      }
      return;
    },
    getParams() {
      let params = {};
      this.fields.map((field) => {
        params[field.field] = this.form[field.field];
      });
      return params;
    },
    async updateFields(val) {
      this.loading = true;
      this.api
        .updateUserData({
          url: "/contact-info/",
          data: this.getParams(),
        })
        .then(() => {
          this.$debug("Успешно обновлены данные юзера", "success", val);

          this.fields.map((field) => {
            this.$store.dispatch("updateUser", {
              updateFieldOnly: {
                field: field.field,
                value: this.form[field.field],
              },
            });
          });
          this.$root[this.subsInfo.plan.button.action](this.subsInfo.plan);
        })
        .catch((error) => {
          this.loading = false;
          this.fieldError =
            this.errorText(error?.response?.data?.phone) ||
            this.errorText(error?.response?.data?.email) ||
            this.$t("Subs.lets.formInvalid");
          this.$debug(error, "error", error);
        });
    },
  },
};
</script>
